interface Props {
  required?: boolean;
}

export function Asterisk({ required }: Props) {
  if (!required) return null;

  return (
    <span className="MuiFormLabel-asterisk MuiInputLabel-asterisk">
      &nbsp;*
    </span>
  );
}
